export default __webpack_public_path__ + "static/media/abil2.97ca0110.webp";